import { Typography } from "@packages/ds";
import styled from "styled-components";

import ButtonDs, { IconControl as IconControlDs } from "ds/Button";

export const Wrapper = styled.div`
  padding: 0;
`;

export const Heading = styled.div`
  display: flex;
  align-items: baseline;
  ${Typography.Title} {
    margin: 0 20px 0 0;
    line-height: 33px;
  }
`;

export const IconControl = styled(IconControlDs)`
  margin: -4px 0 0 8px;
  vertical-align: middle;
`;

export const Button = styled(ButtonDs)`
  margin-left: auto;
`;

const Title = styled.h3`
  font-weight: bold;
  font-size: 15px;
  line-height: 24px;
  margin: 0 0 4px 0;
  color: var(--header-slate-color, var(--slate));
`;

export const List = styled.div`
  padding: 0 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  & + ${Title} {
    margin-top: 32px;
  }
`;

export const EmptyText = styled.div`
  margin-top: 70px;
  margin-bottom: 300px;
  text-align: center;
`;

export const ImageWrapper = styled.div`
  margin: 0 auto 32px;
`;

export const NoBackupsTitle = styled(Typography.Title)`
  margin-bottom: 16px;
`;

export const Paragraph = styled.p`
  margin-bottom: 32px;
  color: var(--section-ebony-color, var(--ebony));
  font-size: 15px;
`;
